<template>
  <div>
    <v-card color="#F6F8FC" flat class="pa-3" >
      <v-row class="px-11">
        <v-col><b class="text1"> #</b></v-col>
        <v-col cols="6"> <b class="text1"> Send to </b></v-col>
        <v-col><b class="text1"> Date at </b></v-col>
      </v-row>
       <v-divider></v-divider>
      <div v-for="(item, i) in historyData" :key="i">
        <v-row class="px-11">
          <v-col class="font-14">#{{ i+1 }}</v-col>
          <v-col cols="6" class="font-14">{{item.email}}</v-col>
          <v-col class="font-14"> {{item.date}}</v-col>
        </v-row>
        <v-divider></v-divider>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "HistoryComponent",
  data() {
    return {
      historyData: [
        {
          email: "emial@asd.com",
          date: "11/2/2022",
        },
        {
          email: "emial@asd.com",
          date: "11/2/2022",
        },
        {
          email: "emial@asd.com",
          date: "11/2/2022",
        },
        {
          email: "emial@asd.com",
          date: "11/2/2022",
        },
        {
          email: "emial@asd.com",
          date: "11/2/2022",
        },
        {
          email: "emial@asd.com",
          date: "11/2/2022",
        },
        {
          email: "emial@asd.com",
          date: "11/2/2022",
        },
      ],
    };
  },
};
</script>


<style scoped>
.text1{
    color: rgba(8, 8, 22, 0.38);
    font-size: 12px;
}
.font-14{
    font-size: 14px;
}
</style>